<div class="ed-search">
  @if (isMulti) {
    <!-- Chips des valeurs sélectionnées -->
    <mat-chip-listbox class="chips" [disabled]="disabled">
      @for (val of selectedValues.length ? selectedValues : selected; track val) {
        <mat-chip-option [selected]="true" (removed)="removeChip(val)">
          {{ labelOf(val) || val }}
          @if (!disabled) {
            <button type="button" class="chip-remove" (click)="removeChip(val)" aria-label="Retirer">✕</button>
          }
        </mat-chip-option>
      }
    </mat-chip-listbox>
  }

  <!-- Saisie via ED textfield avec mat-autocomplete -->
  <ed-textfield
    innerId="edSearchInput"
    [placeholder]="placeholder"
    [ngModel]="inputText"
    (ngModelChange)="onTextChange($event)"
    [disabled]="disabled"
    [matAutocomplete]="auto"
  
    #edInput>
  </ed-textfield>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption($event)">
    @for (opt of safeOptions; track $index) {
      <mat-option [value]="opt" [disabled]="isSelected(opt.value) || opt.disabled">
        {{ opt.label }}
      </mat-option>
    }
    @if (!!inputText && safeOptions.length === 0) {
      <mat-option disabled>Aucun résultat</mat-option>
    }
  </mat-autocomplete>
</div>
